module.exports = __webpack_public_path__ + "static/media/GC_topview_04.0236fa07.png";